export const client = {
  characterCard: {
    hiddenCharacterName: "Hidden character",
    noPhoto: "No photo",
  },

  join: {
    title: "Join Game",
    inputPlaceholder: "Enter join code",
    joinButton: "Join",
    loadingButton: "Checking...",
    errorEmptyCode: "Please enter a join code",
    errorInvalidCode: "Invalid join code or session not available",
  },

  screen: {
    loading: "Loading session…",
    errorPrefix: "Error:",
    notFound: "Session not found",
    defaultTitle: "Game Session",
    modeLabel: "Mode:",
    revealedLabel: "Revealed:",
  },
};
